import {RemotePostResendConfirmPhone} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PostResendConfirmPhone} from 'domain/usecases';

export const makePostResendConfirmPhone = (): PostResendConfirmPhone =>
	new RemotePostResendConfirmPhone(
		makeBFFApiUrl(ProfileChangeDataEndpoints.resendConfirmCellPhone),
		makeAuthorizeHttpClientDecorator(),
	);
